<template>
  <div class="w-full mx-auto h-full flex flex-col justify-center items-center">
    <div class="w-full max-w-md border border-gray-300 p-4">
      <div class="p-4 m-4 w-full flex flex-col items-center justify-center">
        <img src="@/assets/logo.png" alt="logo" class="w-18 h-18 mr-4">
        <span class="my-4 mx-2 text-2xl font-semibold">Nueva contraseña</span>
      </div>
      <template v-if="!token">
        <p class="text-sm text-gray-700 mb-4">
          El enlace no es válido o falta el token. Pedí un nuevo correo de recuperación.
        </p>
      </template>
      <template v-else-if="!done">
        <p class="text-sm text-gray-600 mb-4">
          Elegí una contraseña de al menos 8 caracteres.
        </p>
        <div class="w-full flex justify-start">Nueva contraseña</div>
        <div class="relative w-full my-2">
          <input
            v-model="newPassword"
            :type="showPassword ? 'text' : 'password'"
            class="w-full p-1 pr-10 border border-gray-200 rounded-md"
            :disabled="isLoading"
            autocomplete="new-password"
          >
          <button
            type="button"
            class="absolute right-1 top-1/2 -translate-y-1/2 p-1.5 text-gray-500 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-400 rounded disabled:opacity-50"
            :aria-label="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
            :disabled="isLoading"
            @click="showPassword = !showPassword"
          >
            <font-awesome-icon :icon="['fas', showPassword ? 'eye-slash' : 'eye']" class="text-lg" />
          </button>
        </div>
        <div class="w-full flex justify-start">Confirmar contraseña</div>
        <div class="relative w-full my-2">
          <input
            v-model="confirmPassword"
            :type="showConfirm ? 'text' : 'password'"
            class="w-full p-1 pr-10 border border-gray-200 rounded-md"
            :disabled="isLoading"
            autocomplete="new-password"
          >
          <button
            type="button"
            class="absolute right-1 top-1/2 -translate-y-1/2 p-1.5 text-gray-500 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-400 rounded disabled:opacity-50"
            :aria-label="showConfirm ? 'Ocultar contraseña' : 'Mostrar contraseña'"
            :disabled="isLoading"
            @click="showConfirm = !showConfirm"
          >
            <font-awesome-icon :icon="['fas', showConfirm ? 'eye-slash' : 'eye']" class="text-lg" />
          </button>
        </div>
        <div class="text-red-400 text-sm" v-if="errorMessage">
          {{ errorMessage }}
        </div>
        <button
          v-if="!isLoading"
          type="button"
          class="w-full my-2 px-4 py-2 text-gray-200 bg-gray-800 rounded-md hover:bg-gray-700 focus:outline-none focus:bg-gray-700"
          @click="submit"
        >
          Guardar contraseña
        </button>
        <div v-else class="flex items-center justify-center my-2">
          <span class="h-6 w-6 animate-spin border-2 border-t-blue-500 border-transparent rounded-full" />
        </div>
      </template>
      <div v-else class="text-gray-700 text-sm">
        {{ successMessage }}
      </div>
      <router-link
        :to="{ name: 'login' }"
        class="block mt-4 text-sm text-gray-600 hover:text-gray-900 underline"
      >
        {{ done ? 'Ir al inicio de sesión' : 'Volver al inicio de sesión' }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { resetPasswordWithToken } from '@/service/auth.service'

export default {
  name: 'ResetPasswordView',
  data() {
    return {
      newPassword: '',
      confirmPassword: '',
      isLoading: false,
      done: false,
      successMessage: '',
      errorMessage: null,
      showPassword: false,
      showConfirm: false,
    }
  },
  computed: {
    token() {
      const q = this.$route.query.token
      return typeof q === 'string' ? q : Array.isArray(q) ? q[0] : ''
    },
  },
  watch: {
    '$route.query.token'() {
      this.resetFormState()
    },
  },
  methods: {
    resetFormState() {
      this.newPassword = ''
      this.confirmPassword = ''
      this.errorMessage = null
      this.done = false
      this.successMessage = ''
    },
    async submit() {
      this.errorMessage = null
      if (this.newPassword.length < 8) {
        this.errorMessage = 'La contraseña debe tener al menos 8 caracteres.'
        return
      }
      if (this.newPassword !== this.confirmPassword) {
        this.errorMessage = 'Las contraseñas no coinciden.'
        return
      }
      this.isLoading = true
      try {
        const { data } = await resetPasswordWithToken({
          token: this.token,
          new_password: this.newPassword,
        })
        this.successMessage = data?.message || 'Contraseña actualizada.'
        this.done = true
      } catch (error) {
        const msg = error.response?.data?.message
        this.errorMessage =
          msg || 'No se pudo restablecer la contraseña. El enlace puede haber expirado.'
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
